module.exports = __webpack_public_path__ + "static/logo1-6ae69fb4205b0ac9a81a4e0ad60a1168.svg";